import { P as x, A as s, b as o, n as r, t as m } from "./element-CV9utnHJ.js";
import { P as k } from "./pkt-slot-controller-D7CrjM52.js";
import { e as b, n as g } from "./ref-Dma3n3i8.js";
import { o as w } from "./if-defined-rXcLNTzN.js";
import { o as v } from "./icon-D0IQAVwS.js";
import { e as T } from "./class-map-3ADKve8g.js";
import { u as E } from "./utils-DznhwRXm.js";
import { b as S } from "./booleanish-C9R0tdXH.js";
import { s as p } from "./input-wrapper-CDgenrYA.js";
import "./helptext-TFpeGJ1P.js";
import "./alert-BHSd2Vpj.js";
var D = Object.defineProperty, _ = Object.getOwnPropertyDescriptor, e = (l, a, n, h) => {
  for (var i = h > 1 ? void 0 : h ? _(a, n) : a, d = l.length - 1, u; d >= 0; d--)
    (u = l[d]) && (i = (h ? u(a, n, i) : u(i)) || i);
  return h && i && D(a, n, i), i;
};
let t = class extends x {
  constructor() {
    super(), this.defaultSlot = b(), this.helptextSlot = b(), this.forId = E(), this.label = "", this.helptext = null, this.helptextDropdown = null, this.helptextDropdownButton = null, this.counter = p.props.counter.default, this.counterCurrent = 0, this.counterMaxLength = 0, this.counterError = null, this.counterPosition = "bottom", this.optionalTag = p.props.optionalTag.default, this.optionalText = p.props.optionalText.default, this.requiredTag = p.props.requiredTag.default, this.requiredText = p.props.requiredText.default, this.tagText = null, this.hasError = p.props.hasError.default, this.errorMessage = "", this.disabled = p.props.disabled.default, this.inline = p.props.inline.default, this.ariaDescribedby = void 0, this.hasFieldset = p.props.hasFieldset.default, this.role = "group", this.useWrapper = p.props.useWrapper.default, this.slotController = new k(this, this.defaultSlot, this.helptextSlot);
  }
  updated(l) {
    super.updated(l);
  }
  render() {
    const l = {
      "pkt-inputwrapper": !0,
      "pkt-inputwrapper--error": this.hasError,
      "pkt-inputwrapper--disabled": this.disabled,
      "pkt-inputwrapper--inline": this.inline
    }, a = "pkt-tag pkt-tag--small pkt-tag--thin-text", n = this.ariaDescribedby ? this.ariaDescribedby : this.helptext ? `${this.forId}-helptext` : s, h = () => o`
        ${this.tagText ? o`<span class=${a + " pkt-tag--gray"}>${this.tagText}</span>` : s}
        ${this.optionalTag ? o`<span class=${a + " pkt-tag--blue-light"}>${this.optionalText}</span>` : s}
        ${this.requiredTag ? o`<span class=${a + " pkt-tag--beige"}>${this.requiredText}</span>` : s}
      `, i = () => this.useWrapper ? this.hasFieldset ? o`<legend
            class="pkt-inputwrapper__legend"
            id="${this.forId}-label"
            @click=${this.handleLabelClick}
          >
            ${this.label} ${h()}
          </legend>` : o`<label
            class="pkt-inputwrapper__label"
            for="${this.forId}"
            aria-describedby="${n}"
            id="${this.forId}-label"
            @click=${this.handleLabelClick}
            >${this.label}${h()}</label
          >` : o`<label
          for="${this.forId}"
          class="pkt-sr-only"
          aria-describedby="${n}"
          id="${this.forId}-label"
        >
          ${this.label}
        </label>`, d = () => o`
        <pkt-helptext
          class="${w(this.useWrapper ? void 0 : "pkt-hide")}"
          .forId=${this.forId}
          .helptext=${this.helptext}
          .helptextDropdown=${this.helptextDropdown}
          .helptextDropdownButton=${this.helptextDropdownButton || p.props.helptextDropdownButton.default}
          @toggleHelpText=${($) => {
      this.toggleDropdown($);
    }}
          ${g(this.helptextSlot)}
          name="helptext"
        ></pkt-helptext>
      `, u = () => this.counter ? o`<div class="pkt-input__counter" aria-live="polite" aria-atomic="true">
          ${this.counterError ? this.counterError : s} ${this.counterCurrent || 0}
          ${this.counterMaxLength ? `/${this.counterMaxLength}` : s}
        </div>` : s, y = () => this.hasError && this.errorMessage ? o`<pkt-alert
          skin="error"
          compact
          id=${`${this.forId}-error`}
          aria-live="assertive"
          aria-atomic="true"
        >
          ${v(this.errorMessage)}
        </pkt-alert>` : s, c = () => o`
        ${i()} 
        ${d()}
        ${this.counterPosition === "top" ? u() : s}
        <div class="pkt-contents" ${g(this.defaultSlot)}></div>
        ${this.counterPosition === "bottom" ? u() : s} 
        ${y()}
      `, f = () => this.hasFieldset ? o`<fieldset class="pkt-inputwrapper__fieldset" aria-describedby="${n}">
            ${c()}
          </fieldset>` : o`<div class="pkt-inputwrapper__fieldset">${c()}</div>`;
    return o`<div class=${T(l)}>${f()}</div> `;
  }
  toggleDropdown(l) {
    this.dispatchEvent(
      new CustomEvent("toggleHelpText", {
        bubbles: !1,
        detail: { isOpen: l.detail.isOpen }
      })
    );
  }
  handleLabelClick() {
    this.dispatchEvent(
      new CustomEvent("labelClick", {
        bubbles: !0,
        composed: !0,
        detail: "label clicked"
      })
    );
  }
};
e([
  r({ type: String })
], t.prototype, "forId", 2);
e([
  r({ type: String })
], t.prototype, "label", 2);
e([
  r({ type: String })
], t.prototype, "helptext", 2);
e([
  r({ type: String })
], t.prototype, "helptextDropdown", 2);
e([
  r({ type: String })
], t.prototype, "helptextDropdownButton", 2);
e([
  r({ type: Boolean })
], t.prototype, "counter", 2);
e([
  r({ type: Number })
], t.prototype, "counterCurrent", 2);
e([
  r({ type: Number })
], t.prototype, "counterMaxLength", 2);
e([
  r({ type: String })
], t.prototype, "counterError", 2);
e([
  r({ type: String, reflect: !1 })
], t.prototype, "counterPosition", 2);
e([
  r({ type: Boolean })
], t.prototype, "optionalTag", 2);
e([
  r({ type: String })
], t.prototype, "optionalText", 2);
e([
  r({ type: Boolean })
], t.prototype, "requiredTag", 2);
e([
  r({ type: String })
], t.prototype, "requiredText", 2);
e([
  r({ type: String })
], t.prototype, "tagText", 2);
e([
  r({ type: Boolean })
], t.prototype, "hasError", 2);
e([
  r({ type: String })
], t.prototype, "errorMessage", 2);
e([
  r({ type: Boolean })
], t.prototype, "disabled", 2);
e([
  r({ type: Boolean })
], t.prototype, "inline", 2);
e([
  r({ type: String })
], t.prototype, "ariaDescribedby", 2);
e([
  r({ type: Boolean })
], t.prototype, "hasFieldset", 2);
e([
  r({ type: String, reflect: !0 })
], t.prototype, "role", 2);
e([
  r({ type: Boolean, reflect: !0, converter: S })
], t.prototype, "useWrapper", 2);
t = e([
  m("pkt-input-wrapper")
], t);
export {
  t as P
};
